import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { CNAEIndicadorBadgesModule } from '../../indicador/badges';
import { CNAETableViewComponent } from './cnae-table-view.component';

@NgModule({
    imports: [
        SharedModule,
        CNAEIndicadorBadgesModule
    ],
    declarations: [
        CNAETableViewComponent
    ],
    exports: [
        CNAETableViewComponent
    ]
})
export class CNAETableViewModule { }
